import { useTranslation } from 'react-i18next';
import { Link, useRouteError } from 'react-router-dom';
import { Button } from '@/components/ui/button';

const ErrorPage = () => {
  const { t } = useTranslation();
  const error = useRouteError() as any;
  const isDarkMode = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
  
  // Default to 404 if no status code is available
  const status = error?.status || 404;
  const isAuthError = status === 401 || status === 403;

  return (
    <div className={`min-h-screen flex flex-col items-center justify-center p-5 ${isDarkMode ? 'bg-gray-900 text-white' : 'bg-gray-50 text-gray-900'}`}>
      <div className="w-full max-w-md text-center">
        <h1 className="text-6xl font-bold mb-4">{status}</h1>
        <h2 className="text-2xl font-semibold mb-6">
          {status === 404 && t('errors.pageNotFound', 'Page Not Found')}
          {status === 401 && t('errors.unauthorized', 'Unauthorized')}
          {status === 403 && t('errors.forbidden', 'Forbidden')}
          {status !== 404 && status !== 401 && status !== 403 && t('errors.somethingWentWrong', 'Something Went Wrong')}
        </h2>
        <p className="mb-8 text-gray-500 dark:text-gray-400">
          {status === 404 && t('errors.pageNotFoundDescription', "The page you're looking for doesn't exist or has been moved.")}
          {status === 401 && t('errors.unauthorizedDescription', 'Please log in to access this page.')}
          {status === 403 && t('errors.forbiddenDescription', "You don't have permission to access this page.")}
          {status !== 404 && status !== 401 && status !== 403 && t('errors.unexpectedError', 'An unexpected error occurred.')}
        </p>
        <div className="flex justify-center space-x-4">
          {isAuthError ? (
            <Button asChild>
              <Link to="/login">{t('errors.login', 'Log In')}</Link>
            </Button>
          ) : (
            <>
              <Button variant="outline" asChild>
                <Link to="/">{t('errors.goHome', 'Go Home')}</Link>
              </Button>
              <Button asChild>
                <Link to="/dashboard">{t('errors.dashboard', 'Dashboard')}</Link>
              </Button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ErrorPage; 